import { all, takeLatest, put, call, fork } from 'redux-saga/effects'
import { actions } from './actions'
import { apiV2 } from '../../services/api'
import { extractDropdowns, checkMandatoryFields, cleanEmptyFields } from './callTakers.helpers'

const { getCallTaker, fetchAllCallTakers, createCallTaker, updateCallTaker } = actions

function * getCallTakerRequest () {
  yield takeLatest('GET_CALL_TAKER/REQUEST', function * ({ payload }) {
    try {
      const callTaker = yield call(apiV2.callTakers.getById, payload.id)
      yield put(getCallTaker.success(callTaker))
    } catch (err) {
      yield put(getCallTaker.failure(err))
    }
  })
}

function * fetchAllCallTakersRequest () {
  yield takeLatest('FETCH_ALL_CALL_TAKERS/REQUEST', function * ({ payload }) {
    try {
      const filters = payload && Object.keys(payload).length > 0 ? payload : undefined
      const callTakers = yield call(apiV2.callTakers.getAll, filters)
      yield put(fetchAllCallTakers.success(callTakers))
    } catch (err) {
      yield put(fetchAllCallTakers.failure({ message: 'Failed to fetch call takers, please try again.' }))
    }
  })
}

function* createCallTakerRequest() {
  yield takeLatest('CREATE_CALL_TAKER/REQUEST', function* ({ payload }) {
    try {
      let sanitizedPayload = extractDropdowns(payload)
      sanitizedPayload = cleanEmptyFields(sanitizedPayload)

      const mandatoryFieldErrors = checkMandatoryFields(sanitizedPayload)

      if (mandatoryFieldErrors) {
        yield put(createCallTaker.failure({
          message: mandatoryFieldErrors
        }))

        return
      }

      yield call(apiV2.callTakers.create, sanitizedPayload);

      yield put(createCallTaker.success({
        message: 'User created successfully.'
      }));

    } catch (error) {
      yield put(createCallTaker.failure({
        message: 'Failed to create user, please try again.'
      }));
    }
  })
}

function* updateCallTakerRequest() {
  yield takeLatest('UPDATE_CALL_TAKER/REQUEST', function* ({ payload }) {
    try {
      let sanitizedPayload = extractDropdowns(payload)
      sanitizedPayload = cleanEmptyFields(sanitizedPayload)

      // Exclude 'username' from mandatory fields validation (username cannot be modified)
      const mandatoryFieldErrors = checkMandatoryFields(sanitizedPayload, ['username'])

      if (mandatoryFieldErrors) {
        yield put(updateCallTaker.failure({
          message: mandatoryFieldErrors
        }))

        return
      }

      // Remove username from payload (backend rejects it for updates)
      const { username, ...updatePayload } = sanitizedPayload

      yield call(apiV2.callTakers.update, payload.id, updatePayload);

      yield put(updateCallTaker.success({
        message: 'User updated successfully.'
      }));

    } catch (error) {
      yield put(updateCallTaker.failure({
        message: 'Failed to update user, please try again.'
      }));
    }
  })
}

/**
 * Helper saga that fetches enabled call takers from the API.
 * Always fetches fresh with enabled=true to ensure only active
 * users are returned, avoiding issues with the shared Redux store
 * being populated with all users (including disabled) by ManageUsers.
 */
function * fetchOrSelectCallTakers () {
  const callTakers = yield call(apiV2.callTakers.getAll, { enabled: true })

  return callTakers
}

export { fetchOrSelectCallTakers }

// Watcher sagas
export default function * rootSaga () {
  yield all([
    fork(getCallTakerRequest),
    fork(fetchAllCallTakersRequest),
    fork(createCallTakerRequest),
    fork(updateCallTakerRequest),
  ])
}
